/*
 *  Copyright (C) UMISIS SOLUTIONS SRL - All Rights Reserved
 *  * Unauthorized copying of this file, via any medium is strictly prohibited
 *  * Proprietary and confidential
 *  * Written by Emanuel Gug <manu144x@gmail.com>, September 2018
 *
 */

export default {
  data () {
    return {
      Page: 1,
      PerPage: 15,
      OrderDirection: 'desc',
      OrderBy: 'created_at',
      TotalRows: 1
    }
  },
  computed: {
    paginationParamsObject() {
      return {
        page: this.Page,
        per_page: this.PerPage,
        order_by: this.OrderBy,
        order_direction: this.OrderDirection
      }
    },
    sortMethodsOptions() {
      return [
        { id: 'desc', name: 'Descending' },
        { id: 'asc', name: 'Ascending' },
      ]
    }
  },
  methods: {

  }
}
